const kmToMiles = (km: number) => km * 0.621371;
const threeDigits = (number: number) => {
  const ints = Math.floor(number).toString().length;
  const neededDecimals = Math.max(3 - ints, 0);
  return number.toFixed(neededDecimals);
};

const formatters = i18n => ({
  time: (totalMinutesOrSeconds: number) => {
    const hoursOrMinutes = Math.floor(totalMinutesOrSeconds / 60);
    const remainder = Math.floor(totalMinutesOrSeconds - hoursOrMinutes * 60);
    const hours = Math.floor(hoursOrMinutes / 60);
    const minutes = hoursOrMinutes % 60;
    const duration = [minutes, remainder];

    if (hours >= 1) {
      duration.unshift(hours);
    }

    return duration
      .map((num, index) => `${num < 10 && index !== 0 ? '0' : ''}${num}`)
      .join(':');
  },
  distance: (
    distanceMeters: number,
    useMetricUnits: boolean,
    equipmentType: string
  ) => {
    const distanceKm = distanceMeters / 1000;

    if (equipmentType && equipmentType.toLowerCase() == 'rower') {
      return i18n._translate('%{distance} M', {
        context: 'Distance completed for rower workout in meters',
        distance: Number(distanceMeters.toFixed(0)).toLocaleString(),
      });
    }

    if (useMetricUnits) {
      return i18n._translate('%{distance} KM', {
        context: 'Distance completed for workout in kilometers',
        distance: Number(threeDigits(distanceKm)).toLocaleString(),
      });
    }
    return i18n._translate('%{distance} MI', {
      context: 'Distance completed for workouts in miles',
      distance: Number(threeDigits(kmToMiles(distanceKm))).toLocaleString(),
    });
  },
  calories: (cals: number) =>
    i18n._translate('~%{calories} CALS', {
      context: 'Estimate of calories burned in workout',
      calories: Number(Math.round(cals)).toLocaleString(),
    }),
});

export default formatters;
